<div class="grid">
  @for (img of images(); track img.ImageID; let i = $index) {
    <button
      type="button"
      class="thumb"
      [title]="img.Label || img.Beschreibung"
      (click)="open(i)"
    >
      <img [src]="srcOf(img)" [alt]="img.Beschreibung" />
      <div class="grid-btns" (click)="$event.stopPropagation()">
        <ctrl-btn-delete
          (click)="onDelete(img.ImageID)"
          content=""
        ></ctrl-btn-delete>
      </div>
    </button>
  }
</div>

@if (activeImage(); as cur) {
  <div class="lightbox" (click)="close()">
    <button
      type="button"
      class="btn close"
      (click)="close(); $event.stopPropagation()"
    >
      <i class="fa-solid fa-xmark"></i>
    </button>

    <button
      type="button"
      class="btn nav prev"
      (click)="prev(); $event.stopPropagation()"
      [style.visibility]="this.images().length > 1 ? 'block' : 'hidden'"
    >
      <i class="fa-solid fa-chevron-left"></i>
    </button>

    <div class="full-wrap" (click)="$event.stopPropagation()">
      <div class="content">
        <img class="full" [src]="srcOf(cur)" [alt]="cur['Beschreibung']" />
        <div class="image-inputs">
          <cst-toolbar>
            <div class="delete-btn">
              <ctrl-btn-delete
                (click)="onDelete(cur['ImageID'])"
              ></ctrl-btn-delete>
            </div>
          </cst-toolbar>

          <div class="label">
            <frm-text
              label="Label"
              [formControl]="controls | berichCtlEval: cur['ImageID'] : 'label'"
            ></frm-text>
          </div>
          <div class="description">
            <frm-text
              [multiline]="true"
              [autoSize]="true"
              label="Description"
              [formControl]="controls | berichCtlEval: cur['ImageID'] : 'desc'"
            >
            </frm-text>
          </div>
        </div>
      </div>
    </div>

    <button
      type="button"
      class="btn nav next"
      (click)="next(); $event.stopPropagation()"
      [style.visibility]="this.images().length > 1 ? 'block' : 'hidden'"
    >
      <i class="fa-solid fa-chevron-right"></i>
    </button>
  </div>
}
